import React, { useReducer } from 'react'
import { fileUploadInitialState } from './store/State'
import fileUploadReducer from './store/Reducer'
import FileUploadService from './Service'
import { useSnackbar } from 'notistack'
import { FileType, FileExtension } from 'types/file-upload/IFileUploadParams'
import SessionManagerService from 'smart-components/session-manager/Service'
import IFileUploadResponse from 'types/file-upload/IFileUploadResponse'

const fileUploadContext = {
  state: fileUploadInitialState,
  handlers: {
    onFileSelected: (_file: File) => new Promise<void>(() => {}),
    onFileRemoved: () => {}
  }
}

export type FileUploadContext = typeof fileUploadContext

export const FileUploadContextProvider = React.createContext<FileUploadContext>(fileUploadContext)

const Provider: React.FC = ({ children }) => {
  const [state, dispatch] = useReducer(fileUploadReducer, fileUploadInitialState)
  const { enqueueSnackbar } = useSnackbar()

  const onUploadSuccess = (response: IFileUploadResponse) => {
    enqueueSnackbar('Avatar image changed with success!', {
      variant: 'success',
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right'
      }
    })

    SessionManagerService.setCurrentUser(response.data)
  }

  const onUploadError = (error: string) => {
    enqueueSnackbar(error, {
      variant: 'error',
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right'
      }
    })
  }

  const handlers = {
    onFileSelected: FileUploadService.onFileSelected(dispatch, onUploadSuccess, onUploadError, {
      allowedTypes: ['image'] as FileType[],
      allowedExtensions: ['jpg', 'jpeg', 'png'] as FileExtension[],
      maxSize: 1000
    }),
    onFileRemoved: FileUploadService.onAvatarRemoved(dispatch, onUploadSuccess, onUploadError)
  }

  const contextValue = {
    ...fileUploadContext,
    state,
    handlers
  }

  return <FileUploadContextProvider.Provider value={contextValue}>{children}</FileUploadContextProvider.Provider>
}

export default Provider
